function scroll_trackers() {
  const scroll_tracker = document.querySelector('main > .scroll_tracker');
  let window_height = window.innerHeight;
  // console.log(window_height);
  if( typeof(scroll_tracker) != 'undefined' && scroll_tracker != null ) {
    scroll_tracker.animate(
      {
        right: ['100vw', '0vw']
      },
      {
        duration: 1, // required, but does nothing
        timeline: new ScrollTimeline({
          scrollOffsets: [
            CSS.percent(0),
            new CSSUnitValue(
              document.querySelector('article footer').offsetTop - (window.innerHeight*.8)
              , 'px')
          ]
        })
      }
    )
  }

  const horizontal_selection_scroll_tracker_head = document.querySelectorAll('.section_posts .scroll_tracker .head');
  if( typeof(horizontal_selection_scroll_tracker_head) != 'undefined' && horizontal_selection_scroll_tracker_head != null ) {
    horizontal_selection_scroll_tracker_head.forEach( element => {
      let scrolling_element = element.closest('.section_posts_wrapper');
      if( window.innerWidth < 1024 ) {
        scrolling_element = element.closest('.section_posts');
      }
      element.animate(
        {
          right: ['100%', '1.5rem']
        },
        {
          duration: 1, // required, but does nothing
          fill: 'both',
          timeline: new ScrollTimeline({
            source: scrolling_element,
            orientation: 'horizontal',
            scrollOffsets: [
              CSS.percent(0),
              CSS.percent(100)
            ]
          })
        }
      )
    });
  }

  const cover_elements_set_one = document.querySelectorAll('.latest_news .section_posts article, .culture .section_posts article');
  if( typeof(cover_elements_set_one) != 'undefined' && cover_elements_set_one != null ) {
    let i = 1;
    cover_elements_set_one.forEach( element => {
      element.animate(
        {
          transform: [
            'translateY(' + 30*(i*.4) + '%)',
            'translateY(0)'
          ]
        },
        {
          duration: 1, // required, but does nothing
          fill: 'both',
          timeline: new ScrollTimeline({
            scrollOffsets: [
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - (window_height * 1.15)),
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - (window_height*0.3))
            ]
          })
        }
      )
      i++;
    });
  }

  const cover_elements_set_two = document.querySelectorAll('.insights .section_posts article');
  if( typeof(cover_elements_set_two) != 'undefined' && cover_elements_set_two != null ) {
    let i = 1;
    cover_elements_set_two.forEach( element => {
      element.animate(
        {
          transform: [
            'translateX(' + 30*(i*.4) + '%)',
            'translateX(0)'
          ]
        },
        {
          duration: 1, // required, but does nothing
          fill: 'both',
          timeline: new ScrollTimeline({
            scrollOffsets: [
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - (window_height * 1.15)),
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - (window_height*0.5))
            ]
          })
        }
      )
      i++;
    });
  }
  const cover_elements_set_four = document.querySelectorAll('.zoo_digital_labs .section_posts article');
  if( typeof(cover_elements_set_four) != 'undefined' && cover_elements_set_four != null ) {
    let i = 1;
    cover_elements_set_four.forEach( element => {
      element.animate(
        {
          transform: [
            'translateX(' + 30*(i*.4) + '%)',
            'translateX(0)'
          ]
        },
        {
          duration: 1, // required, but does nothing
          fill: 'both',
          timeline: new ScrollTimeline({
            scrollOffsets: [
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - (window_height * 1.15)),
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - (window_height*0.5))
            ]
          })
        }
      )
      i++;
    });
  }
  const grid_view_elements = document.querySelectorAll('.single-news_sections .section_posts_wrapper article, .single-news_sections .section_posts_wrapper .feature, .page-template-single-events-index .section_posts_wrapper article, .single-post footer .grid article');
  if( typeof(grid_view_elements) != 'undefined' && grid_view_elements != null ) {
    let i = 1;
    let x = 30;
    grid_view_elements.forEach( element => {
      let transform = [];
      if( i == 1 ) {
        transform = [
          'translateX(-' + x + '%) translateY(' + (x*0.5) + '%)',
          'translateX(0) translateY(0)'
        ];
      } else if ( i == 2 ) {
        transform = [
          'translateX(-' + (x*0.2) + '%) translateY(' + (x*1.2) + '%)',
          'translateX(0) translateY(0)'
        ];
      } else if ( i == 3 ) {
        transform = [
          'translateX(' + (x*0.1) + '%) translateY(' + (x*1.4) + '%)',
          'translateX(0) translateY(0)'
        ];
      } else if ( i == 4 ) {
        transform = [
          'translateX(' + x + '%) translateY(' + x + '%)',
          'translateX(0) translateY(0)'
        ];
        i = 0;
      }
      element.animate(
        {
          transform: transform
        },
        {
          duration: 1, // required, but does nothing
          fill: 'both',
          timeline: new ScrollTimeline({
            scrollOffsets: [
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - (window_height * 1.15)),
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top - (window_height*0.75))
            ]
          })
        }
      )
      i++;
    });
  }
}

// function debug_current_scroll() {
//   console.log(window.pageYOffset);
// }

scroll_trackers();
